import React, {Fragment, useState} from 'react';
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import ListEdit from "../UI/ListEdit";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import ModalForm from "../UI/ModalForm";
import Box from "../UI/Box";
import {toast} from "react-toastify";
import Select from 'react-select';
import {useSmartLockPermissions} from "../../hooks/useSmartLockPermissions";
import {useCustomers} from "../../hooks/useCustomers";
import {createSmartLockPermission, deleteSmartLockPermission} from "../../api/smartLockPermissionApiClient";
import {convertToDisplayDateTime, CUSTOMER_STATUS_ACTIVE} from "../../utility/utility";

const SmartLockPermissionList = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [submitCount, setSubmitCount] = useState(0);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const {customerSmartLockPermissions, pagination} = useSmartLockPermissions(page, pageSize, submitCount);
    const {customers} = useCustomers(1, 200, null, null, CUSTOMER_STATUS_ACTIVE, null, 0);

    const smartLockPermissionList = customerSmartLockPermissions.map((item) => ({
        ...item,
        createdAt : convertToDisplayDateTime(item.createdAt)
    }));

    const handleCreateButtonClick = () => {
        setSelectedCustomer(null);
        setShowModal(true)
    }

    const handleCreateSubmit = (event) => {
        event.preventDefault();
        const customerId = selectedCustomer ? parseInt(selectedCustomer.value, 10) : null;

        createSmartLockPermission(customerId)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handleDeleteIconClick = (customerId) => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Are you sure?')) {
            deleteSmartLockPermission(customerId)
                .then(() => {
                    setSubmitCount(prevCount => prevCount + 1);
                    toast.success('Success!');
                })
                .catch(
                    (error) => {
                        toast.error(error.message);
                    }
                );
        }
    }

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Customer Name',
        'Created At',
        'Actions'
    ];

    const columns = {
        functionParams : ['customerId'],
        dataKeys       : [
            'customerName',
            'createdAt'
        ],
    }

    return (
        <Fragment>
            <Box>
                <Button title='Create smart lock permission' handleClick={handleCreateButtonClick}/>
                <ListEdit
                    headers={listHeaders}
                    items={smartLockPermissionList}
                    columns={columns}
                    pagination={pagination}
                    handleDeleteIconClick={handleDeleteIconClick}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
            {showModal && (
                <Modal>
                    <form onSubmit={handleCreateSubmit}>
                        <ModalForm
                            title='Create smart lock permission'
                            saveButtonTitle='Create'
                            handleCancelButtonClick={() => setShowModal(false)}
                        >
                            <ModalFormInputRow title='Customer'>
                                <Select
                                    value={selectedCustomer}
                                    onChange={setSelectedCustomer}
                                    options={(customers || []).map(customer => ({
                                        value : customer.id,
                                        label : `${customer.firstName} ${customer.lastName} ${customer.email ? `(${customer.email})` : ''}`
                                    }))}
                                    className="basic-select"
                                    classNamePrefix="select"
                                    placeholder="Search customers..."
                                    menuPortalTarget={document.body}
                                    styles={{menuPortal : (base) => ({...base, zIndex : 9999})}}
                                />
                            </ModalFormInputRow>
                        </ModalForm>
                    </form>
                </Modal>
            )}
        </Fragment>
    );
}

export default SmartLockPermissionList;
